import {
  RTWSummaryItem,
  RTWSummaryOverviewData,
} from "../../../../utils/models";

import classNames from "../pdf.module.scss";
import pdfClasses from "../../../themed/pdf/pdf.module.scss";

import weldNumber from "../../../../assets/paut-images/weldNumber.png";
import viReport from "../../../../assets/paut-images/viReport.png";
import shearwave from "../../../../assets/paut-images/shearwave.png";
import result from "../../../../assets/paut-images/result.png";
import lptResult from "../../../../assets/paut-images/lptResult.png";
import defectType from "../../../../assets/paut-images/defectType.png";
import rtwSummaryImage from "../../../../assets/images/rtwSummaryImage.png";

const RTWSummary = (props: RTWSummaryOverviewData) => {
  const getResultClassName = (): string => {
    return props.result === "Accepted"
      ? classNames.pautSummaryResultValueAccept
      : classNames.pautSummaryResultValueReject;
  };

  const data: RTWSummaryItem[] = props.data ?? [];

  return (
    <div className={classNames.pautSummary}>
      <div className={classNames.pautSummaryResult}>
        <div className={classNames.pautSummaryResultLabel}>Result</div>
        <div className={classNames.pautSummaryResultValue}>
          <span className={getResultClassName()}>{props.result}</span>
        </div>
      </div>

      <table className={pdfClasses["pdf-table"]}>
        <thead>
          <tr>
            <th>Weld Number</th>
            <th className={pdfClasses.bgWarning}>Visual Inspection Result</th>
            <th className={pdfClasses.bgWarning}>LPT Result</th>
            <th className={pdfClasses.bgWarning}>Shear Wave Result</th>
            <th className={pdfClasses.bgWarning}>Defect Type</th>
            <th className={pdfClasses.bgWarning}>Accept / Reject</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <img src={weldNumber} alt="Weld Number" />
            </td>
            <td>
              <img src={viReport} alt="Visual Inspection Result" />
            </td>
            <td>
              <img src={lptResult} alt="LPT Result" />
            </td>
            <td>
              <img src={shearwave} alt="Shear Wave Result" />
            </td>
            <td>
              <img src={defectType} alt="Defect Type" />
            </td>
            <td>
              <img src={result} alt="Accept / Reject" />
            </td>
          </tr>

          <tr>
            <td>{props.weldNumber}</td>
            <td>{props.viResult}</td>
            <td>{props.lptResult}</td>
            <td>{props.shearWaveResult}</td>
            <td>{props.defectType}</td>
            <td>
              <span className={getResultClassName()}>{props.result}</span>
            </td>
          </tr>
        </tbody>
      </table>

      <div className="mt-4">
        <table className={pdfClasses["pdf-table"]}>
          <thead>
            <tr>
              <th>RT Part Number</th>
              <th>Artifacts</th>
              <th className={pdfClasses.bgDanger}>Discontinuities</th>
              <th>Discontinuities Length (mm)</th>
              <th>Discontinuities Type</th>
              <th>Defect</th>
              <th>Defect Type</th>
              <th>Defect Length (mm)</th>
              <th>Diameter of Pipe (inches)</th>
              <th>Schedule</th>
              <th>Pipe Specification</th>
              <th className={pdfClasses.bgWarning}>DRT Result</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={12}>
                <img src={rtwSummaryImage} alt="RT Weld Summary" />
              </td>
            </tr>

            {data.map((item: RTWSummaryItem) => (
              <tr>
                <td>{item.rtPartNumber}</td>
                <td>{item.artifacts}</td>
                <td className={pdfClasses.bgDanger}>{item.discontinuities}</td>
                <td>{item.discontinuitiesLength}</td>
                <td>{item.discontinuitiesType}</td>
                <td>{item.defect}</td>
                <td>{item.defectType}</td>
                <td>{item.defectLength}</td>
                <td>{item.pipeDiameter}</td>
                <td>{item.schedule}</td>
                <td>{item.pipeSpec}</td>
                <td>{item.drtResult}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className={classNames.pautSummaryRemark}>
        EI = Elongated Indication, IP = Incomplete Penetration, LOF =Lack of
        Fusion, RI = Rounded Indication, UC = Undercutting, CS=Concave Surface,
        CR=Concave Root,BT= Burn-Through, CI = Crack Indication, EP= Excess
        Penetration
      </div>
    </div>
  );
};

export default RTWSummary;
